var exports = {
  "Zd": "EmbedDebuggerTab.module__form___VnFfVD",
  "v1": "EmbedDebuggerTab.module__formControls___VnFfVD",
  "Wn": "EmbedDebuggerTab.module__urlField___VnFfVD",
  "Y2": "EmbedDebuggerTab.module__urlInput___VnFfVD",
  "RC": "EmbedDebuggerTab.module__submitButton___VnFfVD",
  "Xv": "EmbedDebuggerTab.module__results___VnFfVD",
  "KR": "EmbedDebuggerTab.module__embedPreview___VnFfVD",
  "Dy": "EmbedDebuggerTab.module__codeSurface___VnFfVD",
  "qS": "EmbedDebuggerTab.module__statusText___VnFfVD",
  "kc": "EmbedDebuggerTab.module__errorText___VnFfVD",
};

module.exports = exports;
